var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 41",
    style: {
      enableBackground: "new 0 0 102 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#C5C4C4;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st2{fill:#C5C4C4;}\r\n\t.st3{fill:#616160;}\r\n\t.st4{fill:none;}\r\n\t.st5{font-family:'OpenSans-SemiBold';}\r\n\t.st6{font-size:8px;}\r\n\t.st7{fill:#C4C4C4;}\r\n\t.st8{enable-background:new    ;}\r\n\t.st9{fill:#020203;}\r\n\t.st10{fill:none;stroke:#D3D3D3;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st11{fill:#D3D3D3;}\r\n\t.st12{fill:none;stroke:#C5C4C4;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#616160;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#616160;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st16{fill:#616160;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st18{fill:#1D70B8;}\r\n\t.st19{fill:#FFFFFF;stroke:#C5C4C4;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st20{fill:none;stroke:#616160;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st21{fill:none;stroke:#D3D3D3;stroke-width:0.5;}\r\n\t.st22{fill:#FFFFFF;stroke:#616160;}\r\n\t.st23{fill:none;stroke:#616160;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st24{fill:#FFFFFF;stroke:#616160;stroke-width:1.5;}\r\n\t.st25{fill:#C5C4C4;stroke:#C5C4C4;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st26{opacity:0.6;}\r\n\t.st27{opacity:0.6;fill:#C5C4C4;}\r\n\t.st28{fill:#FFFFFF;stroke:#616160;stroke-width:0.5;}\r\n\t.st29{fill:none;stroke:#616160;stroke-width:0.5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.4718,
    y: 17.4986,
    className: "st4",
    width: 36.2926,
    height: 7.4184
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 41.4719 23.5793)",
    className: "st3 st5 st6"
  }, "Checklist"), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.5039,13.8218h-8.5718c-1.2207,0-2.2139,0.9932-2.2139,2.2144v8.5713c0,1.2212,0.9932,2.2144,2.2139,2.2144 h8.5718c1.2212,0,2.2144-0.9932,2.2144-2.2144v-8.5713C37.7183,14.8149,36.7251,13.8218,35.5039,13.8218z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.0059,23.4531 27.228,20.6753 27.9351,19.9683 30.0059,22.0391 34.501,17.5439 35.208,18.251  "
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox2);
export default __webpack_public_path__ + "static/media/Checkbox2.4578910dc7cf41d039cf983b66e315a4.svg";
export { ForwardRef as ReactComponent };